<!-- 历史数据 -->
<template>
  <div class="app-container">
    <div class="app-content">
      <el-card class="energy-history" shadow="never">
        <template slot="header">
          <el-form inline size="small">
            <el-form-item :label="$t('text.lb')">
              <el-button-group>
                <el-button :type="dateType==='day'? 'primary': ''" @click="dateType='day'">{{ $t('text.r') }}</el-button>
                <el-button :type="dateType==='month'? 'primary': ''" @click="dateType='month'">{{ $t('text.y') }}</el-button>
                <el-button :type="dateType==='year'? 'primary': ''" @click="dateType='year'">{{ $t('text.n') }}</el-button>
                <el-button :type="dateType==='total'? 'primary': ''" @click="dateType='total'">{{ $t('text.z') }}</el-button>
              </el-button-group>
            </el-form-item>
            <el-form-item v-show="dateType!=='total'" :label="$t('text.shijian')">
              <el-date-picker v-show="dateType==='day'" v-model="queryParams.time" type="date" style="margin-top: 0;" />
              <el-date-picker v-show="dateType==='month'" v-model="queryParams.time" type="month" style="margin-top: 0;" />
              <el-date-picker v-show="dateType==='year'" v-model="queryParams.time" type="year" style="margin-top: 0;" />
            </el-form-item>
            <el-form-item :label="$t('text.sb')">
              <el-select v-model="queryParams.device" clearable value-key="sn">
                <el-option-group v-for="item in deviceOptions" :key="item.id" :label="item.sn">
                  <el-option v-for="device in item.children" :key="device.id" :label="device.sn" :value="{id:device.id,pvNum:device.pvNum}" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item v-show="dateType === 'day'" :label="$t('text.cs')">
              <el-select v-model="queryParams.fields">
                <el-option v-for="item in computedParam" :key="item.value" :label="$t(item.label)" :value="item" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleQuery">{{ $t('button.cx') }}</el-button>
            </el-form-item>
          </el-form>
        </template>
        <template slot="default">
          <toggle-chart
            :data="chart.data"
            :columns="chart.columns"
            :setting="chart.setting"
            :loading="loading"
            :extend="chart.extend"
            :format="chart.format"
            :unit="chart.unit"
          />
        </template>
      </el-card>
    </div>
  </div>
</template>

<script>
import ToggleChart from '@views/Charts/ToggleChart2.vue'
import { GetInvertersForHistory } from '@apis/Stations.js'
import { GetInvHistoryData } from '@apis/Statistics.js'
import { getMonthLength, combineData } from '@utils'
export default {
  components: {
    ToggleChart
  },
  data () {
    return {
      loading: false, // 图表加载
      dateType: 'day',
      queryParams: {},
      deviceOptions: [], // 设备选项
      paramOptions: [ // 参数选项默认
        { label: 'sec.axdy', value: 'nlua', unit: 'V' },
        { label: 'sec.bxdy', value: 'nlub', unit: 'V' },
        { label: 'sec.cxdy', value: 'nluc', unit: 'V' },
        { label: 'sec.axdl', value: 'nlia', unit: 'A' },
        { label: 'sec.bxdl', value: 'nlib', unit: 'A' },
        { label: 'sec.cxdl', value: 'nlic', unit: 'A' },
        { label: 'sec.axgl', value: 'npa', unit: 'kW' },
        { label: 'sec.bxgl', value: 'npb', unit: 'kW' },
        { label: 'sec.cxgl', value: 'npc', unit: 'kW' },
        { label: 'text.dwpl', value: 'nfrq', unit: 'Hz' },
        { label: 'sec.nbqwd', value: 'ninvtemper', unit: '℃' },
        { label: 'sec.hjwd', value: 'nenvtemper', unit: '℃' },
        { label: 'sec.axfzdy', value: 'flua', unit: 'V' },
        { label: 'sec.bxfzdy', value: 'flub', unit: 'V' },
        { label: 'sec.cxfzdy', value: 'fluc', unit: 'V' },
        { label: 'sec.axfzdl', value: 'fia', unit: 'A' },
        { label: 'sec.bxfzdl', value: 'fib', unit: 'A' },
        { label: 'sec.cxfzdl', value: 'fic', unit: 'A' },
        { label: 'sec.axfzgl', value: 'fpa', unit: 'kW' },
        { label: 'sec.bxfzgl', value: 'fpb', unit: 'kW' },
        { label: 'sec.cxfzgl', value: 'fpc', unit: 'kW' },
        { label: 'sec.axfzl', value: 'fra', unit: '%' },
        { label: 'sec.bxfzl', value: 'frb', unit: '%' },
        { label: 'sec.cxfzl', value: 'frc', unit: '%' },
        { label: 'sec.dcdy', value: 'bu', unit: 'V' },
        { label: 'sec.dcdl', value: 'bi', unit: 'A' },
        { label: 'sec.dcdl1', value: 'bi1', unit: 'A' },
        { label: 'sec.dcdl2', value: 'bi2', unit: 'A' },
        { label: 'sec.dcdl3', value: 'bi3', unit: 'A' },
        { label: 'sec.dcsydl', value: 'bsoc', unit: '%' },
        { label: 'sec.dcwendu', value: 'bmscelltemper', unit: '℃' },
      ],
      // 图表
      chart: {
        data: [],
        columns: ['time', 'val1'],
        setting: { labelMap: {}, type: 'line' },
        format: '',
        unit: '',
        extend: {
          grid: {
            right: 30,
            left: 30,
            bottom: 10,
            top: 30
          },
          yAxis: {
            name: '',
            position: 'left'
          },
          legend: {
            show: true
          }
        }
      },
    }
  },
  computed: {
    computedParam () {
      const pv = []
      if (this.queryParams.device && this.queryParams.device.pvNum) {
        for (let i = 1; i <= this.queryParams.device.pvNum; i++) {
          pv.push({ label: 'PV' + i + this.$t('text.dy'), value: 'upv' + i, unit: 'V' })
          pv.push({ label: 'PV' + i + this.$t('text.dl'), value: 'ipv' + i, unit: 'A' })
          pv.push({ label: 'PV' + i + this.$t('text.gl'), value: 'ppv' + i, unit: 'kW' })
        }
      }
      return this.paramOptions.concat(pv)
    }
  },
  watch: {
    dateType () {
      this.chart.data = []
    }
  },
  created () {
    this.getDeviceList()
  },
  methods: {
    // 查询
    handleQuery () {
      this.loading = true
      this.chart.setting.type = 'line'
      let mask = 'yyyy-MM'
      let mask1 = ''
      let mask2 = ''
      if (this.dateType === 'day') {
        mask1 = 'yyyy-MM-dd 00:00:00'
        mask2 = 'yyyy-MM-dd 23:59:59'
      } else if (this.dateType === 'month') {
        const l = getMonthLength(this.queryParams.time)
        mask = 'yyyy-MM-dd'
        mask1 = 'yyyy-MM-01 00:00:00'
        mask2 = 'yyyy-MM-' + l + ' 23:59:59'
      } else if (this.dateType === 'year') {
        mask = 'yyyy-MM'
        mask1 = 'yyyy-01-01 00:00:00'
        mask2 = 'yyyy-12-31 23:59:59'
      } else if (this.dateType === 'total') {
        mask = 'yyyy'
        this.chart.setting.type = 'histogram'
      }
      GetInvHistoryData({
        dateType: this.dateType,
        startTime: this.$parseTime(this.queryParams.time, mask1),
        endTime: this.$parseTime(this.queryParams.time, mask2),
        deviceId: this.queryParams.device && this.queryParams.device.id,
        fields: [this.queryParams.fields && this.queryParams.fields.value]
      })
        .then(res => {
          this.loading = false

          if (this.dateType === 'day') {
            this.chart.columns = ['time', 'val1']
            this.chart.format = 'hh:mm'
            this.chart.unit = this.queryParams.fields.unit
            this.chart.extend.yAxis.name = this.queryParams.fields.unit
            this.chart.setting.labelMap = { val1: this.queryParams.fields.label }
            this.chart.data = res.data[this.queryParams.fields.value]
          } else {
            this.chart.columns = ['time', 'F', 'R', 'C']
            this.chart.unit = 'kW'
            this.chart.extend.yAxis.name = 'kW'
            this.chart.format = mask
            this.chart.setting.labelMap = { F: '发电量', R: '放电量', C: '耗电量' }
            const data = []
            Object.keys(res.data).forEach(key => {
              res.data[key].forEach(v => {
                v[key] = v.val1
                delete v.val1
                data.push(v)
              })
            })
            this.chart.data = combineData(data, 'time')
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 获取设备列表
    getDeviceList () {
      GetInvertersForHistory({
        id: this.$store.getters.station.id
      })
        .then(res => {
          this.deviceOptions = res.data
        })
    }
  }
}
</script>
<style scoped>
.energy-history {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}
.energy-history>>> .el-card__header {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
}
.energy-history>>> .el-card__header .el-form{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.energy-history>>> .el-card__header .el-form .el-form-item{
  margin-bottom: 0;
}

.energy-history>>> .el-card__body {
  width: 100%;
  height: calc(100% - 50px);
  padding: 0 20px;
  box-sizing: border-box;
}
</style>

